import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  image: 'https://cdn.magicpatterns.com/uploads/88Zxsk7PtYbY2Mvu74T8T3/100_VIRAL_HOOKS.png',
  alt: '100 Viral Hooks You Can Copy and Paste book cover',
  title: '100 Viral Hooks You Can Copy and Paste',
  desc: 'Attention-grabbing hooks designed to stop the scroll and increase engagement.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/ngo3d4ZYUtdQ4M2AdWxxt5/MAKE_CHAT_GPT_SOUND_LIKE_YOU.png',
  alt: 'Create a Consistent Brand Voice book cover',
  title: 'Create a Consistent Brand Voice',
  desc: 'A simple guide to help AI responses match your tone, personality and brand style.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/rRWQ7ZbFz44ZRU7x91FxZ9/30_DAYS_OF_INSTAGRAM.png',
  alt: '30 Days of Instagram Ideas book cover',
  title: '30 Days of Instagram Ideas',
  desc: 'Done-for-you content ideas to eliminate content fatigue.'
}];
export function BonusesSection() {
  return <section id="bonuses" className="py-32 bg-black relative overflow-hidden border-t border-white/5" data-id="element-81">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[500px] bg-gold-radial opacity-20 pointer-events-none" data-id="element-82" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-83">
        <div className="text-center mb-24" data-id="element-84">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-gold text-sm font-bold tracking-[0.2em] uppercase mb-6 block" data-id="element-85">
            Included Bonuses
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="font-display font-black uppercase text-4xl md:text-5xl lg:text-6xl text-offwhite tracking-tight leading-[1.05]" data-id="element-86">
            Three premium guides.{' '}
            <span className="text-gold" data-id="element-87">Included free.</span>
          </motion.h2>
        </div>

        <div className="grid lg:grid-cols-3 gap-12 lg:gap-8" data-id="element-88">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.7,
          delay: i * 0.15,
          ease: 'easeOut'
        }} className="flex flex-col items-center text-center group" data-id="element-89">
              <div className="relative mb-10" data-id="element-90">
                {/* Ambient glow */}
                <div className="absolute inset-0 bg-gold-radial opacity-40 blur-2xl scale-110 pointer-events-none" data-id="element-91" />
                <img src={bonus.image} alt={bonus.alt} className="relative z-10 max-h-[320px] sm:max-h-[380px] lg:max-h-[420px] w-auto object-contain drop-shadow-[0_25px_50px_rgba(0,0,0,0.6)] transition-transform duration-500 group-hover:-translate-y-2 group-hover:scale-[1.02]" data-id="element-92" />
              </div>
              <div className="inline-block px-3 py-1 bg-gold/10 border border-gold/20 text-gold text-xs font-bold tracking-widest uppercase rounded-full mb-4" data-id="element-93">
                Included Free
              </div>
              <h3 className="text-xl font-display font-bold text-offwhite mb-3 tracking-tight" data-id="element-94">
                {bonus.title}
              </h3>
              <p className="text-muted max-w-sm" data-id="element-95">{bonus.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-24 text-center border-t border-white/10 pt-12" data-id="element-96">
          <p className="text-xl text-muted" data-id="element-97">
            Total value: <span className="line-through opacity-50" data-id="element-98">$147</span> —{' '}
            <span className="text-gold font-display font-black text-3xl ml-2 tracking-tight" data-id="element-99">
              Yours free
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}